module.exports = __webpack_public_path__ + "img/mine.813cef84.png";